import { FieldProps } from 'formik';
import * as React from 'react';
import { string } from 'yup';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const PostalCode: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label='ZIP Code'
		maskPattern={[ /[0-9]/, /\d/, /\d/, /\d/, /\d/ ]}
		required={required}
		type='tel'
		{...field}
	/>;
};

export function postalCodeValidation (required: boolean = false) {
	const value = string().matches(/\d{5}/, 'Please enter a valid ZIP code.');

	if (required) {
		return value.required('Please enter your ZIP code.');
	}

	return value;
}

export default PostalCode;
